module.exports = __webpack_public_path__ + "img/footer.b0b62796.jpg";